<template>
  <v-container class="page-wrap" fluid>
    
    <v-row justify="center" no-gutters>
      <v-col cols="12" class="page-col">
        
        <div v-if="loading" class="py-10 text-center">
          <v-progress-circular indeterminate size="34" />
          <div class="text-body-2 grey--text text--darken-1 mt-3">
            Loading campaign...
          </div>
        </div>

        <!-- Expired -->
        <div v-else-if="Campaigns && Campaigns.isActive === false">
          <v-card class="card-soft" outlined>
            <v-card-text class="pa-6 text-center">
              <lottie
                class="mb-3"
                :options="defaultOptions"
                v-on:animCreated="handleAnimation"
              />
              <div class="text-h5 font-weight-bold">This Link has Expired</div>
              <div class="text-body-2 grey--text text--darken-1 mt-2">
                Please contact customer support to receive a new URL
              </div>
            </v-card-text>
          </v-card>
        </div>

        <!-- Active -->
        <div v-else-if="Business && Campaigns && Campaigns.isActive">
          <!-- Header Card -->
          <v-card class="card-soft mb-4" outlined>
            <v-card-text class="pa-4">
              <div class="d-flex align-center">
                <v-avatar v-if="Business.imageUrl" size="52" class="mr-3">
                  <img :src="Business.imageUrl" alt="Logo" />
                </v-avatar>

                <div class="min-w-0">
                  <div class="text-subtitle-1 font-weight-bold text-truncate">
                    {{ Business.name }}
                  </div>

                  <div
                    class="text-caption grey--text text--darken-1"
                    v-if="Business.phoneNumber"
                  >
                    {{ Business.phoneNumber | USPhoneNumber }}
                  </div>

                  <div
                    class="text-caption grey--text text--darken-2"
                    v-if="hasAddress"
                  >
                    <span v-if="Business.address">{{ Business.address }}</span>
                    <span v-if="Business.city">, {{ Business.city }}</span>
                    <span v-if="Business.state">, {{ Business.state }}</span>
                    <span v-if="Business.zip"> {{ Business.zip }}</span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <!-- Campaign Hero -->
          <v-card class="card-soft mb-4" outlined>
            <div v-if="Campaigns.imageUrl">
              <v-img :src="Campaigns.imageUrl" height="220" class="hero-img" />
            </div>

            <v-card-text class="pa-4">
              <div class="text-h6 font-weight-bold">
                {{ Campaigns.name }}
              </div>

              <div class="text-caption grey--text text--darken-1 mt-1">
                Created {{ Campaigns.createdAt | moment("from", "now") }}
              </div>

              <!-- <div class="mt-3 text-body-2 grey--text text--darken-2" v-if="Campaigns.description">
                {{ stripHTML(Campaigns.description) }}
              </div> -->
            </v-card-text>
          </v-card>

          <!-- Donation UI Wrapper -->
          <v-card class="card-soft" outlined>
            <v-card-text class="pa-4">
              <div class="text-subtitle-2 font-weight-bold mb-2">
                Choose your donation
              </div>
              <div class="text-body-2 grey--text text--darken-1 mb-4">
                Select an option below to continue.
              </div>
              <!-- Sponsor vs Donation -->
              <div v-if="Campaigns.type === 'sponsor'">
                <DonationNoLimit v-if="sponsorStyle === 'fast'" />
                <DonationSponsor v-else-if="sponsorStyle === 'student'" />
                <DonationSponsor v-else-if="sponsorStyle === 'units'" />
                <DonationSponsor v-else />
              </div>
              <div v-else>
                <DonationCampaign />
              </div>
            </v-card-text>
          </v-card>

          <!-- Footer -->
          <div class="text-center mt-4 footer-note">
            Powered by <span class="font-weight-bold">taleem.app</span>
            <span class="mx-1">|</span>
            <span class="caption">{{ version }}</span>
          </div>
        </div>

        <!-- Fallback -->
        <div v-else class="py-10 text-center">
          <div class="text-body-2 grey--text text--darken-1">
            Campaign not found.
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DonationNoLimit from "@/modules/Campaign/view/Donation/DonationNoLimit.vue";
import DonationSponsor from "@/modules/Campaign/view/Donation/DonationSponsor.vue";
import DonationCampaign from "@/modules/Campaign/view/Donation/DonationCampaign.vue";
import donationService from "@/modules/Campaign/service.js";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/pinjump.json";

const pjson = require("../../../../../package.json");

export default {
  name: "Camp-Donation",
  components: {
    DonationNoLimit,
    DonationSponsor,
    DonationCampaign,
    Lottie,
  },
  data() {
    return {
      loading: true,
      Business: null,
      Campaigns: null,
      donationLimit: false,
      defaultOptions: {
        animationData: animationData.default,
      },
    };
  },
  computed: {
    // sponsorStyle() {
    //   return this.Campaigns?.metadata?.detailStyle || "normal";
    // },
    sponsorStyle() {
      const md = this.Campaigns?.metadata || {};

      // New way (preferred)
      if (md.detailStyle) return md.detailStyle;

      // Backward compatible (old way)
      if (md.donationLimit === true) return "fast";

      return "normal";
    },
    version() {
      return pjson.version;
    },
    hasAddress() {
      return (
        this.Business &&
        (this.Business.address ||
          this.Business.city ||
          this.Business.state ||
          this.Business.zip)
      );
    },
  },
  created() {
    this.loadCampaign();
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    stripHTML(html) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = html || "";
      return tempElement.textContent || tempElement.innerText || "";
    },
    loadCampaign() {
      const code = this.$route.params.id;

      this.loading = true;

      donationService
        .getCampaignById(code)
        .then((response) => {
          const data = response && response.data ? response.data : null;

          if (!data) {
            this.loading = false;
            this.$router.push({ name: "pagenotfound" });
            return;
          }

          if (data.isActive === false) {
            this.loading = false;
            this.$router.push({ name: "pagenotfound" });
            return;
          }

          this.Campaigns = data;
          this.Business = data.Business || null;

          // donationLimit
          const meta = data.metadata || {};
          this.donationLimit = meta && meta.donationLimit ? true : false;

          this.loading = false;
        })
        .catch((error) => {
          console.log("error getting campaign", error);
          this.loading = false;
          this.$router.push({ name: "pagenotfound" });
        });
    },
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 16px;
  padding-bottom: 120px;
}
.card-soft {
  border-radius: 18px;
  overflow: hidden;
}

.hero-img {
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
}

.min-w-0 {
  min-width: 0;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer-note {
  opacity: 0.85;
}

/* ✅ Mobile: full width
   ✅ Desktop: wide, but not ridiculous */
.page-col {
  width: 100%;
  max-width: 1400px; /* change to 1600px if you want even wider */
  margin: 0 auto;
}

/* Give a little more padding on big screens */
@media (min-width: 960px) {
  .page-wrap {
    padding: 24px 28px 140px;
  }
}
</style>